export default __webpack_public_path__ + "static/media/calendar.b575ef0b.svg";